import { toast } from "react-toastify";
import { authErrors } from "../utils/firebaseErrors";

export const showToast = (message, status) => {
  if (status === "error") {
    toast.error(message);
  } else {
    toast.success(message);
  }
};

export const getErrorMessage = (errorCode) => {
  return authErrors[errorCode] || "An unknown error occurred.";
};
